import * as React from "react";

export const UpSquareArrowSvg = (props) => {
  return (
    <svg
      width={114}
      height={114}
      viewBox="0 0 114 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.666 33.88V80.1767C113.666 100.18 100.797 113.667 81.5926 113.667H32.4626C13.2526 113.667 0.332642 100.18 0.332642 80.1767V33.88C0.332642 13.82 13.2526 0.333313 32.4626 0.333313H81.5926C100.797 0.333313 113.666 13.82 113.666 33.88ZM52.7489 44.1366V80.1199C52.7489 82.4999 54.6756 84.3699 56.9989 84.3699C59.3789 84.3699 61.2489 82.4999 61.2489 80.1199V44.1366L75.2456 58.1899C76.0389 58.9832 77.1723 59.4366 78.2489 59.4366C79.3199 59.4366 80.4023 58.9832 81.2523 58.1899C82.8956 56.5466 82.8956 53.8266 81.2523 52.1832L60.0023 30.8199C58.4156 29.2332 55.5823 29.2332 53.9956 30.8199L32.7456 52.1832C31.1023 53.8266 31.1023 56.5466 32.7456 58.1899C34.4456 59.8332 37.1089 59.8332 38.8089 58.1899L52.7489 44.1366Z"
        fill="#E3E3E3"
      />
    </svg>
  );
};
